import {format} from "date-fns";
import {idempiereDate} from "./idempiereDate";
import {idempiereType} from "./idempiereType";

const getActiveShipmentIDs = (activeDeliveries) => {
    const shipmentIDs = {};
    if(activeDeliveries) {
        for(const delivery of activeDeliveries) {
            shipmentIDs[delivery.id] = true;
        }
    }
    return shipmentIDs;
}

const getDisplayDate = (date) => {
    const dayName = format(date, 'EEEE');
    const monthName = format(date, 'MMMM');

    return dayName + " " + date.getDate() + "th " + monthName + " " + date.getFullYear();
}

const setInfo = (order) => {
    order.info = [];

    const isPending = !order.orderShipments;
    if(!isPending && order.has_undeliverd_bo > 0) {
        order.info.push("Order contains incomplete back ordering")
    }

    // Set status message

    const idDate = idempiereDate.getDate(order.DatePromised);
    const displayDate = getDisplayDate(idDate);

    if(!isPending) {
        order.status = "Delivered " + displayDate;
    } else {
        order.status = "Will be delivered " + displayDate;
    }

}

const buildOrderDetail = (orders, activeDeliveries) => {
    const deliveryIDs = getActiveShipmentIDs(activeDeliveries);
    const isOutForDelivery = (order) => {
        if(order.orderShipments) {
            for(const shipmentID of idempiereType.parseArray(order.orderShipments)) {
                if(deliveryIDs[shipmentID]) return true;
            }
        }
        return deliveryIDs[order.id]
    };

    const outForDelivery = [];
    const pending = [];
    const completed = [];

    if(orders) {
        for (const originalOrderObj of orders) {
            const order = {...originalOrderObj};
            setInfo(order);

            if (isOutForDelivery(order)) {
                outForDelivery.push(order);
            } else if (order.orderShipments) {
                completed.push(order);
            } else {
                pending.push(order);
            }
        }
    }

    return {
        outForDelivery,
        pending,
        completed
    }
}

export const accountService = {
    buildOrderDetail
}